import script from "./LessonCard.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonCard.vue?vue&type=script&setup=true&lang=js"

import "./LessonCard.vue?vue&type=style&index=0&id=5487a5f3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5487a5f3"]])

export default __exports__